import React from "react";
import { SupportedLanguages } from "@repo/database";
import { useTranslation } from "react-i18next";

import { MultiSelect } from "./multi-select";

export default function LanguagePicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation("common");

  const languageOptions = Object.values(SupportedLanguages).map((language) => ({
    label: t(`LanguagePicker.options.${language}`),
    value: language,
  }));
  return (
    <MultiSelect
      maxSelect={1}
      placeholder={t("LanguagePicker.placeholder")}
      onValueChange={(value) => {
        if (!value[0]) return;
        onChange(value[0]);
      }}
      options={languageOptions}
      defaultValue={[value]}
      value={value}
    />
  );
}
